import { Component, Host, h, Element, Prop } from '@stencil/core';

const icons: Record<string, string> = {
  feature: 'fa-solid fa-grid-2 fa-fw',
  epic: 'aha-icon aha-icon-epic-solid fa-fw',
  requirement: 'fa-solid fa-list fa-fw',
};
const iconColors: Record<string, string> = {
  feature: 'var(--theme-blue-text)',
  epic: 'var(--theme-button-warning-hovered)',
  requirement: 'var(--theme-button-warning-hovered)',
};

/**
 * Displays a record in a chart tooltip, use within an `aha-chart-tooltip`.
 * @slot default - Name of record.
 * @slot header-right - Right aligned content in the header, typically a date.
 * @slot footer - Footer content, typically an `aha-icon` and a value.
 * @prop {string} recordType - Type of record, can be 'Feature', 'Epic', or 'Requirement'.
 * @prop {string} referenceNum - Reference number of the record, typically the record ID or number.
 */
@Component({
  tag: 'aha-chart-tooltip-record',
  styleUrl: 'aha-chart-tooltip-record.css',
  shadow: true,
})
export class AhaChartTooltipRecord {
  @Element() host!: HTMLAhaChartTooltipRecordElement;
  @Prop() recordType?: 'Feature' | 'Epic' | 'Requirement' = 'Feature';
  @Prop() referenceNum?: string;
  render() {
    const icon = icons[this.recordType?.toLowerCase() ?? ''] ?? icons.feature;
    const iconColor = iconColors[this.recordType?.toLowerCase() ?? ''] ?? iconColors.feature;

    return (
      <Host>
        <div id="header">
          <div
            id="icon"
            style={{
              backgroundColor: iconColor,
            }}
          >
            <aha-icon icon={icon} />
          </div>
          <span>
            <span id="type">{this.recordType}</span> {this.referenceNum}
          </span>
          <slot name="header-right"></slot>
        </div>
        <div id="body">
          <slot></slot>
        </div>
        <slot name="footer"></slot>
      </Host>
    );
  }
}
